import { useQuery } from "@tanstack/react-query";
import { createFileRoute, useParams, useSearch } from "@tanstack/react-router";
import { EMPTY_ORG_ID } from "@/constants/org";
import { recordQueryOptions } from "@/services/record/record.options";
import { AdminRecordTypeFullIndexTabContent } from "./AdminRecordTypeFullPage";

const FULL_INDEX =
	"/_authenticated/(admin-app)/_admin/admin/configuration/recordTypes/$recordTypeId/full/" as const;

const FULL_PARENT =
	"/_authenticated/(admin-app)/_admin/admin/configuration/recordTypes/$recordTypeId/full" as const;

export const Route = createFileRoute(FULL_INDEX)({
	component: AdminRecordTypeFullIndexRoute,
});

function AdminRecordTypeFullIndexRoute() {
	const params = useParams({ from: FULL_PARENT });
	const search = useSearch({ from: FULL_PARENT });

	const detailQuery = useQuery(
		recordQueryOptions.recordTypeDetail(params.recordTypeId, {
			organizationId: EMPTY_ORG_ID,
		}),
	);

	const recordType = detailQuery.data ?? null;

	if (!recordType) {
		return null;
	}

	return (
		<AdminRecordTypeFullIndexTabContent
			tab={search.tab}
			recordType={recordType}
		/>
	);
}
